import { arrowLeftOrder, LetterIcon } from '../../../assets/icons';
import { useForm ,Controller} from 'react-hook-form';
import { useContext, useEffect, useState } from 'react';
import { FilterOrderContext } from '../../../context/FilterOrderContext';
import ReactSlider from 'react-slider';
import './odo.css';
import Button from '../../buttons/Button';
import { useTranslation } from 'react-i18next';
import Counter from '../../inputs/Counter';
const Odo = ({ back }) => {
  const { t } = useTranslation();
  const filterOrderContext = useContext(FilterOrderContext);
  const { control, register, handleSubmit, setValue } = useForm({
    defaultValues: { odo: [100000, 500000] , odoFrom:1000 , odoTo:5000 },
  });

  const [odo, setOdo] = useState([100000, 500000]);
  const handleSliderChange = (newValues) => {
    setOdo(newValues, setValue('odo', newValues));
  };

  const onSubmit = (data) => {
    filterOrderContext.setOdoFrom(data.odoFrom);
    filterOrderContext.setOdoTo(data.odoTo, back());
  };
  return (
    <div>
      <img
        src={arrowLeftOrder}
        className="my-2 cursor-pointer"
        onClick={back}
      />
      <div className="text-[#3E0292] text-[15px] font-500">
        {t('filterModal.selectOdo')}
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="p-4">

<div className="grid md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 sm:grid-cols-1 gap-x-4">
              <Controller
                name="odoFrom"
                defaultValue={0}
                control={control}
                render={({ field }) => (
                  <Counter
                    {...field}
                    initialValue={filterOrderContext.odoFrom}
                    icon={LetterIcon}
                    label={t('myOrders.kilometers')}
                    placeholder={t('myOrders.from')}
                    step={1000}
                  />
                )}
              />
              <Controller
                name="odoTo"
                defaultValue={0}
                control={control}
                render={({ field }) => (
                  <Counter
                    {...field}
                    initialValue={filterOrderContext.odoTo}
                    icon={''}
                    label={t('myOrders.to')}
                    placeholder={t('myOrders.to')}
                    className="mt-2"
                    step={5000}
                  />
                )}
              />
            </div>

        <div className="grid grid-cols-2 gap-x-2 mt-10">
          <Button
            type="submit"
            dark={false}
            className="bg-[#00CEBC] border-[#00CEBC] rounded-[10px]"
            title={t('filterModal.confirm')}
          />
          <Button
            type="submit"
            dark={false}
            className="bg-[#FF4342] border-[#FF4342] rounded-[10px]"
            title={t('filterModal.cancel')}
          />
        </div>
      </form>
    </div>
  );
};
export default Odo;
